import ReactModal from "react-modal";
import { BoxModal } from "../../../components/boxModal";

import './styles.css'
import { useEffect } from "react";
import { FaPlus } from "react-icons/fa6";

export function ManageAccessModal({ isOpen, companyUsers, setManageAccessModal, setCreateAccessModal, handleOpenUpdateModal, listCompanyUser }) {
  const companyUserStatusMap = {
    'active': 'Ativo',
    'inactive': 'Bloqueado',
  }

  useEffect(() => {
    listCompanyUser()
  }, [])

  return (
    <ReactModal isOpen={isOpen} className="change-modal" overlayClassName="overlay-change-password-modal">
      <BoxModal title='Gerenciar seus acessos' maxWidth={680} close={() => setManageAccessModal(false)}>
          <div className="modal-content border-0 gap-2">
            {companyUsers?.map(access => (
              <div className="d-flex justify-content-between align-items-center flex-wrap p-3 shadow-lg">
                <div className="mb-2">
                  <div className="fw-semibold">Nome: {access?.name}</div>
                  <div className="text-muted small">Telefone: {access?.phone}</div>
                  <div className="text-muted small">Email: {access?.mail}</div>
                  <div className={`mt-1 small ${access?.status === 'active' ? 'text-success' : 'text-danger'}`}>
                    <i className="bi bi-circle-fill me-1"></i>Status: {companyUserStatusMap[access?.status]}
                  </div>
                </div>

                <button className="btn btn-success col-md-3" onClick={() => handleOpenUpdateModal(access)}>Gerenciar</button>
              </div>
            ))}
          </div>
          <div>
            <button className="d-flex flex-row gap-2 align-items-center" onClick={() => setCreateAccessModal(true)}>
              <FaPlus />
              Adicionar novo acesso
              </button>
          </div>
      </BoxModal>
    </ReactModal>
  )
}